<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { CheckCircle, Sparkles } from 'lucide-vue-next'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

const props = defineProps({
  session: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['close'])

const route = useRoute()
const isOpen = ref(false)

// Check if we should show the success modal
const shouldShowSuccessModal = computed(() => {
  return route.query.billing_success === 'true'
})

// Initialize modal visibility
onMounted(() => {
  if (shouldShowSuccessModal.value) {
    isOpen.value = true
  }
})

function handleClose() {
  isOpen.value = false
  emit('close')

  // Remove the query parameter from URL without page reload
  const url = new URL(window.location)
  url.searchParams.delete('billing_success')
  url.searchParams.delete('billing_canceled')
  window.history.replaceState({}, document.title, url.pathname + url.search)
}

function handleContinue() {
  handleClose()
}
</script>

<template>
  <Dialog v-model:open="isOpen" @update:open="!$event && handleClose()">
    <DialogContent class="max-w-md">
      <DialogHeader class="text-center">
        <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
          <CheckCircle class="h-8 w-8 text-green-600" />
        </div>

        <DialogTitle class="text-2xl font-bold text-center">
          <div class="flex items-center justify-center gap-2">
            Félicitations !
            <Sparkles class="h-6 w-6 text-yellow-500" />
          </div>
        </DialogTitle>

        <DialogDescription class="text-center text-lg mt-2">
          Votre abonnement Selfwise a été activé avec succès ! Vous avez maintenant accès à toutes les fonctionnalités premium.
        </DialogDescription>
      </DialogHeader>

      <div class="mt-8 space-y-4">
        <div class="rounded-lg bg-blue-50 p-4">
          <h3 class="font-semibold text-blue-900 mb-2">
            Ce qui vous attend :
          </h3>
          <ul class="text-sm text-blue-800 space-y-1">
            <li>✨ Accès complet à toutes les fonctionnalités</li>
            <li>🎯 Outils d'analyse avancés</li>
            <li>🚀 Support prioritaire</li>
            <li>📈 Rapports détaillés</li>
          </ul>
        </div>

        <div class="flex justify-center pt-4">
          <Button class="w-full" @click="handleContinue">
            Commencer l'expérience premium
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
